/**
 * Constants used throughout the mock interview module
 */

// session storage key
export const SEARCH_MOCK_INTERVIEW_COMPANY_KEY = "SEARCH_MOCK_INTERVIEW_COMPANY";
export const SEARCH_MOCK_INTERVIEW_ROLE_KEY = "SEARCH_MOCK_INTERVIEW_ROLE";

// Nudge IDs
export const NUDGE_ID_INTERVIEW_PREP_PROFILE_UPDATE = "interview_prep_profile_update";
